import frame13627898394Png from '@listening/assets/astro/images/Frame-1362789839-4.png';
import frame13627898395Png from '@listening/assets/astro/images/Frame-1362789839-5.png';
import frame13627898396Png from '@listening/assets/astro/images/Frame-1362789839-6.png';

export function AutoSkipCitationsSection() {
  return (
    <section className='flex flex-col items-center gap-18 px-5 sm:px-14 lg:p-18'>
      <div className='flex max-w-[1296px] flex-col gap-8 sm:gap-14 lg:gap-18'>
        <div className='flex flex-col items-center gap-6 pb-6' id='notes'>
          <h2 className='max-w-[748px] text-center text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px] lg:text-[44px] lg:leading-[47px]'>
            <span className='text-azure-595'>Automatically skip</span>{' '}
            citations, references, and footnotes
          </h2>
        </div>
        <div className='flex flex-wrap justify-around gap-8 sm:gap-14 lg:flex-nowrap lg:gap-8'>
          <div className='relative flex w-full flex-col gap-10 rounded-[32px] bg-white p-5 [box-shadow:0_5px_36px_rgba(0,_0,_0,_.2)] sm:p-6 lg:w-auto'>
            <div className='relative flex [aspect-ratio:auto] min-h-[220px] flex-[0_auto] items-end justify-center overflow-visible rounded-2xl bg-mist-330 object-cover sm:min-h-[300px] lg:[aspect-ratio:16_/_9] lg:min-h-[auto]'>
              <img
                alt='Text'
                className='[aspect-ratio:auto] rounded-[16px] bg-mist-330 object-contain'
                loading='lazy'
                src={frame13627898394Png}
              />
              <div className='absolute bottom-[-25px] flex items-center justify-center rounded-full bg-white p-[4px]'>
                <div className='static flex size-[43px] items-center justify-center rounded-full bg-azure-455/10 px-[12px] py-[8px]'>
                  <div className='text-center text-[20px] leading-[27px] font-[600] text-azure-455'>
                    1
                  </div>
                </div>
              </div>
            </div>
            <div className='flex flex-col items-center gap-[8px]'>
              <div className='text-center text-[18px] leading-[24px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px]'>
                Inline citations
              </div>
            </div>
            <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-[16px] bg-azure-455/15'>
              <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-[16px] bg-azure-455/15' />
            </div>
          </div>
          <div className='relative flex w-full flex-col gap-10 rounded-[32px] bg-white p-5 [box-shadow:0_5px_36px_rgba(0,_0,_0,_.2)] sm:p-6 lg:w-auto'>
            <div className='relative flex [aspect-ratio:auto] min-h-[220px] flex-[0_auto] items-end justify-center overflow-visible rounded-2xl bg-mist-330 object-cover sm:min-h-[300px] lg:[aspect-ratio:16_/_9] lg:min-h-[auto]'>
              <img
                alt='Text'
                className='[aspect-ratio:auto] rounded-[16px] bg-mist-330 object-contain'
                loading='eager'
                src={frame13627898395Png}
              />
              <div className='absolute bottom-[-25px] flex items-center justify-center rounded-full bg-white p-[4px]'>
                <div className='static flex size-[43px] items-center justify-center rounded-full bg-azure-455/10 px-[12px] py-[8px]'>
                  <div className='text-center text-[20px] leading-[27px] font-[600] text-azure-455'>
                    2
                  </div>
                </div>
              </div>
            </div>
            <div className='flex flex-col items-center gap-[8px]'>
              <div className='text-center text-[18px] leading-[24px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px]'>
                Footnotes
              </div>
            </div>
            <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-[16px] bg-azure-455/15'>
              <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-[16px] bg-azure-455/15' />
            </div>
          </div>
          <div className='relative flex w-full flex-col gap-[40px] rounded-[32px] bg-white p-5 [box-shadow:0_5px_36px_rgba(0,_0,_0,_.2)] sm:p-6 lg:w-auto'>
            <div className='relative flex [aspect-ratio:auto] min-h-[220px] flex-[0_auto] items-end justify-center overflow-visible rounded-2xl bg-mist-330 object-cover sm:min-h-[300px] lg:[aspect-ratio:16_/_9] lg:min-h-[auto]'>
              <img
                alt='Text'
                className='[aspect-ratio:auto] h-full rounded-[16px] bg-mist-330 object-contain'
                loading='lazy'
                src={frame13627898396Png}
              />
              <div className='absolute bottom-[-25px] flex items-center justify-center rounded-full bg-white p-[4px]'>
                <div className='static flex size-[43px] items-center justify-center rounded-full bg-azure-455/10 px-[12px] py-[8px]'>
                  <div className='text-center text-[20px] leading-[27px] font-[600] text-azure-455'>
                    3
                  </div>
                </div>
              </div>
            </div>
            <div className='flex flex-col items-center gap-[8px]'>
              <div className='text-center text-[18px] leading-[24px] font-[500] text-neutral-945 sm:text-[24px] sm:leading-[32px]'>
                References
              </div>
            </div>
            <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-[16px] bg-azure-455/15'>
              <div className='absolute inset-x-[12px] top-[5px] bottom-[-12px] -z-10 rounded-[16px] bg-azure-455/15' />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
